<template>
  <div>
    <v-container fluid class="py-0">
      <v-row>
        <v-card flat color="transparent" class="mx-auto py-6 text-center">
          <v-card-title class="display-1 mb-2">{{ $t("recruit.title") }}</v-card-title>
          <v-card-subtitle class="subtitle-1">RECRUIT</v-card-subtitle>
        </v-card>
      </v-row>
      <v-row no-gutters class="text-center" align="start">
        <v-spacer></v-spacer>
        <v-col :cols='isMobile?12:"false"'>
          <v-card class="mb-4" flat tile color="transparent">
            <v-card-title :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' v-html="$t('recruit.mainPage.content')">{{ $t('recruit.mainPage.content') }}</v-card-title>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
          <v-card flat color="transparent" class="mx-auto mt-2 mb-6 text-center">
            <v-card-title class="font-weight-regular mb-2">{{ $t('recruit.mainPage.title1') }}</v-card-title>
          </v-card>
      </v-row>
      <v-row>
          <v-spacer></v-spacer>
          <v-img :width='isMobile?"":"650"' src="../assets/recruit/1-1.jpg">
            <v-row align="center" class="white--text fill-height text-center">
                <v-spacer></v-spacer>
                <v-col>
                  <v-card flat tile color="transparent" >
                    <v-row justify="center">
                    <v-card-title :class='(isMobile?"title ":"display-2 ")+"white--text text-center"' style="white-space:nowrap;">
                      ON CHALLENGE NO LIFE
                    </v-card-title>
                    </v-row> 
                    <v-divider color="white"></v-divider>
                    <v-card-actions>
                      <v-row justify="center">
                      <v-btn text :class='(isMobile?"title ":"display-1 ")+"white--text"' style="white-space:nowrap;" to="/recruit-2019">
                          {{ $t('recruit.mainPage.title1') }}
                      </v-btn>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
          </v-img>
          <v-spacer></v-spacer>
        </v-row>
      <v-row>
          <v-card flat color="transparent" class="mx-auto mt-2 mb-6 text-center">
            <v-card-title class="font-weight-regular mb-2">{{ $t('recruit.mainPage.title2') }}</v-card-title>
          </v-card>
      </v-row>
      <!-- 非手机端 -->
      <v-row no-gutters justify="center" class="d-none d-sm-flex">
        <v-spacer></v-spacer>
        <v-col v-for="(recruit,index) in recruits" :key="recruit.title" class="mx-0 px-0">
          <v-avatar tile size=220 class="mx-0">
            <v-img  :src="recruit.imageUrl" :position="index===3?'top left':'center center'">
              <v-row align="center" class="white--text fill-height text-center px-0 mx-0">
                <v-col>
                  <v-card flat tile color="transparent" >
                    <v-row justify="center">
                    <v-card-title class="white--text subtitle-1 text-center py-0" style="white-space:nowrap;">
                      {{ $t(recruit.title) }}
                    </v-card-title>
                    </v-row> 
                    <v-card-text class="white--text py-0">
                        <v-btn :to="recruit.to" small fab color="rgba(255,255,255,0.2)" class="white--text subtitle-1">GO</v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-img>
          </v-avatar>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <!-- 手机端 -->
      <v-row justify="center" class="d-flex d-sm-none">
        <v-col v-for="(recruit,index) in recruits" :key="recruit.title" class="mx-0 px-0 py-1">
            <v-img height=200 :src="recruit.imageUrl" :position="index===3?'top left':'center center'">
              <v-row align="center" class="white--text fill-height text-center px-0 mx-0">
                <v-col>
                  <v-card flat tile color="transparent" >
                    <v-row justify="center">
                    <v-card-title class="white--text title text-center py-0" style="white-space:nowrap;">
                      {{ $t(recruit.title) }}
                    </v-card-title>
                    </v-row> 
                    <v-card-text class="white--text py-0">
                        <v-btn width=100 :to="recruit.to" rounded color="rgba(255,255,255,0.2)" class="white--text subtitle-1">GO</v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-img>
        </v-col>
      </v-row>
    </v-container>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciContactFooter from "@/components/TciContactFooter.vue";

export default {
  name: "CompanyService",
  components: {
    "tci-contact-footer": TciContactFooter
  },
  data: () => ({
    recruits: [
      {"imageUrl":require('../assets/recruit/2-1.jpg'),"title":"recruit.mainPage.recruit_manager","to":"/recruit-project-manager"},
      {"imageUrl":require('../assets/recruit/2-2.jpg'),"title":"recruit.mainPage.recruit_dev","to":"/recruit-bdeveloper"},
      {"imageUrl":require('../assets/recruit/2-3.jpg'),"title":"recruit.mainPage.recruit_trans","to":"/recruit-translate"},
      {"imageUrl":require('../assets/recruit/2-4.jpg'),"title":"recruit.mainPage.recruit_sap","to":"/recruit-bserver-engineer"}
    ],
    isMobile: false
  }),
  methods:{
  
  },
  mounted() {
    this.isMobile = this.$vuetify.breakpoint.xs;
  }
};
</script>
